import { getStorage } from './localStorage';

export const isAdmin = () => {
  const acl = getStorage('acl', { format: true });
  const names = acl.groups.map(group => group.name);
  return names.includes('Super Admin') || names.includes('Admin Questões');
};

export const isTeacher = () => {
  const acl = getStorage('acl', { format: true });
  return acl.groups.map(group => group.name).includes('Professor Questões');
};

export const isOperator = () => {
  const acl = getStorage('acl', { format: true });
  return acl.groups.map(group => group.name).includes('Cadastrador Questões');
};

export const hasSpecificPermission = (permission) => {
  const permissions = getStorage('permissions', { format: true });
  return permissions?.some((p) => p.id === permission);
};

export const hasPermission = (permission) => {
  const permissions = getStorage('permissions', { format: true });
  return permissions?.some((p) => p.id === '*' || p.id === permission);
};

export const aclPlugin = {
  install(Vue, options) {
    const { users } = options;
    if (!users) throw new Error('You need to pass users to acl plugin');

    const acl = {
      getAdmins: () => users.MODERADORES,
      getTeachers: () => users.TEACHERS,
      getOperators: () => users.CADASTRADORES,
      isTeacher() {
        if (isAdmin()) return true;
        if (isTeacher()) return true;
        return false;
      },
      isOperator() {
        if (isAdmin()) return true;
        if (isOperator()) return true;
        return false;
      },
      isAdmin,
      isExactlyTeacher: () => isTeacher(),
      isExactlyOperator: () => isOperator(),
      getCurrentUserLogged() {
        return getStorage('user') || '';
      },
      getAcl() {
        return getStorage('acl', { format: true }) || {};
      },
      hasPermission,
      hasSpecificPermission,
    };


    Object.defineProperty(Vue.prototype, '$acl', {
      get: () => acl,
      set() {
        throw new Error('You can\'t set $acl');
      },
    });
  },
};
